import { Box } from '@mui/material';

interface NoteBoxProps {
  onEventClick: (offsetNum: any, currentDate: any, shiftId?: any) => void;
  currentDay: any;

  currentIndex: number;
  notes: any;
}
const NoteBox: React.FC<NoteBoxProps> = ({
  onEventClick,
  currentDay,

  currentIndex,
  notes,
}) => {
  return (
    <Box id={'noteBox_' + currentIndex} sx={{ minHeight: '84px' }}>
      {notes.map((noteData: any, index: any) => {
        return (
          <Box
            className="noteInnerBox"
            onClick={() => {
              onEventClick(currentDay, noteData.id);
            }}
          >
            {noteData.note && <Box>{noteData.note}</Box>}
          </Box>
        );
      })}
    </Box>
  );
};

export default NoteBox;
